import { render, staticRenderFns } from "./ServiceRadioWithMarketSegmentFormPart.vue?vue&type=template&id=2b320656"
import script from "./ServiceRadioWithMarketSegmentFormPart.vue?vue&type=script&lang=js"
export * from "./ServiceRadioWithMarketSegmentFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports